/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Marker classes only — keep this file free of session/auth imports so
 * LocalNetworkProfile can depend on these tokens without an ES-module cycle.
 */
/** Angular DI token for the NetworkInfo HTTP resource (factory product). */
export class NetworkInfoResource {
}

/** Angular DI token for the Network HTTP resource (factory product). */
export class NetworkResource {
}
